import React from 'react'
import styled from 'styled-components'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import { StyledTableRow0ListArticle, Wrapper0ListArticle } from '.'
import TableCell from '@material-ui/core/TableCell'
import skeletonFade from '../../../../../../modules/mixins/skeleton-fade'

const SkeletonTableRow = styled(StyledTableRow0ListArticle)`
  ${skeletonFade}
`

const SkeletonListArticle = ({ number, ...props }) => {
  const rows = []
  for (let index = 0; index < number; index++) {
    rows.push(
      <SkeletonTableRow key={index}>
        <TableCell />
      </SkeletonTableRow>,
    )
  }
  return (
    <Wrapper0ListArticle {...props}>
      <TableContainer>
        <Table>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
    </Wrapper0ListArticle>
  )
}

SkeletonListArticle.defaultProps = {
  number: 15,
}

export default SkeletonListArticle
